// Version 4.0.3 of Select2 contains an error so it's not loaded through bower
// See: https://github.com/select2/select2/pull/4356
// Imported version contains the fix
import 'select2/dist/js/select2.full';

export default function () {
	$('.js-select2').each(function () {
		const context = this;

		let options = {
			'language': {
				"noResults": () => {
					return $(this).attr('data-i18n-noResults') || 'Geen resultaten gevonden';
				},
				'searching': () => {
					return $(this).attr('data-i18n-searching') || 'Zoeken...';
				}
			},
			width: 'resolve'
		};

		if ($(this).hasClass('js-select2-marker')) {
			options.ajax = {
				url: $(this).attr('data-url'),
				dataType: 'json',
				delay: 250,
				cache: false,
				data: function (params) {
					return {
						searchTerm: params.term,
						activeMembersOnly: $(this).attr('data-rule-required'),
						showTopMarkers: params.term ? false : true
					};
				},
				processResults: function (data) {
					if (data.Error) {
						return {
							results: [{
								error: data.Error
							}]
						};
					} else {
						var result = $.map(data, function (obj) {
							if (obj.title) {
								// we have found a group
								return {
									text: obj.title || '',
									children: 
										$.map(obj.children, function (child) {
											return {
												id: child.Id || ($(this).attr('data-rule-required') ? null : '|' + child.FullName),
												text: child.FullName,
												photoUrl: child.PhotoUrl || $(context).attr('data-defaultphotourl'),
												city: child.City || '',
												error: child.Error
											}
										})
								}
							} else {
								return {
									id: obj.Id || ($(this).attr('data-rule-required') ? null : '|' + obj.FullName),
									text: obj.FullName,
									photoUrl: obj.PhotoUrl || $(context).attr('data-defaultphotourl'),
									city: obj.City || '',
									error: obj.Error
								};
							}
						});						

						return {
							results: result
						};
					}
				},
				error: function (response) {
					// console.log(response);
				}
			};

			options.placeholder = {
				id: -1,
				text: $(this).attr('data-i18n-placeholder')
			};
			options.escapeMarkup = function (markup) {
				return markup;
			};
			options.templateResult = function (marker) {
				if (marker.loading) {
					return marker.text;
				}

				if (marker.error) {
					return marker.error;
				}

				if (marker.children) {
					const groupMarkup = '<strong>' + marker.text + '</strong>';
					return groupMarkup;
				}

				const markup = '<div class="c-marker">' +
					'<div class="c-marker__headshot c-headshot"><img src="' + marker.photoUrl + '" /></div>' +
					'<div class="c-marker__text">' +
					'<div class="c-marker__title">' + marker.text + '</div>' +
					'<div class="c-marker__subtitle">' + marker.city + '</div>' +
					'</div>' +
					'</div>';

				return markup;
			};
		}

		$(this).select2(options);
	});

	//TODO: refactor $(this).valid();
	// Validate dropdowns on change
	$('select').on('change', function () {
		//$(this).valid();
	});
}